import React from 'react'

import Text from './Text'
import Icon from '../../packages/kiti/components/shapes/Icon'

const Link = ({ href, children, ...props }) => {
  return (
    <a
      href={href}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        textDecoration: 'none',
        width: 'fit-content'
      }}
    >
      <Text {...props}>{children}</Text>
      <Icon name="BsLink45Deg" size="0.85rem" color="#000000" />
    </a>
  )
}

export default Link
